export default __webpack_public_path__ + "static/media/7.10.d0943b1f.mp3";